import { populateDashboard, getRegisters, fetchAllData, createRegister, updateRegister, deleteRegister } from '../helpers/fakerBackEnd';

export const useApi = () => ({

  /*===== Dashboard =====*/

  getData: async (filterDate: number) => {
    let days = filterDate;
    let targetDate = new Date();
    targetDate.setDate(targetDate.getDate() - (Number(filterDate) - 1));
    const formattedDate = `${targetDate.getFullYear()}-${(targetDate.getMonth() + 1).toString().padStart(2, '0')}-${targetDate.getDate().toString().padStart(2, '0')}`;

    const response = populateDashboard(formattedDate, days);
    return response;
  },

  /*===== Register / Tables =====*/

  getRegisters: async (endpoint: string, currentPage: number, query: string = '') => {
    const response = getRegisters(endpoint, currentPage, query);
    return response;
  },

  fetchAllData: async (endpoint: string, currentPage: number, query: string = '') => {
    const response = fetchAllData(endpoint, currentPage, query);
    return response;
  },

  createRegister: async (endpoint: string, data: Object) => {
    const response = createRegister(endpoint, data);
    return response;
  },

  updateRegister: async (endpoint: string, id: string, data: Object) => {
    const response = updateRegister(endpoint, id, data);
    return response;
  },

  deleteRegister: async (endpoint: string, id: string) => {
    const response = deleteRegister(endpoint, id);
    return response;
  },

  /*===== Authentication =====*/

  validateToken: async (token: string) => {
    const storageToken = localStorage.getItem('token');
    if (storageToken !== null) {
      const storage = JSON.parse(localStorage.getItem('users')!);
      const result = storage.find((user: any) => user.id === storageToken);
      return {
        user: {
          ...result
        }
      }
    } else {
      return { "isValid": false }
    }
  },

  signin: async (email: string, password: string) => {
    const storage = localStorage.getItem('users');
    const result = JSON.parse(storage!).find((user: any) => user.email === email);
    const token = result.id;
    localStorage.setItem('token', result.id);
    return {
      token,
      user: {
        ...result
      }
    };
  },

  logout: async () => {
    return {
      status: true
    }
  },

});
